/*
 * @Description: 版权资源中心模块入口 (原资源中心先拆分为版权资源与网络资源)
 * @Author: pu.yuchun
 * @LastEditors: cc
 * @Date: 2019-10-28 17:15:09
 * @LastEditTime: 2021-04-20 14:16:12
 */
angular
    .module('resourceCenterModule', [
        'resourceCenterRouterModule',
        'util.checkbox',
        'compositeFilterPanelModule', // 版权资源筛选项
        'util.trsGoTopModule',
        'trsSetColumnsModule',
        'trsAreaSelectModule',
        'trsInputSuggestModule',
        'resCtrModalModule',
        'resourceCenterinitComDataModule',
        'resourceCenterLeftModule',
        'resourceCenterSharedModule',
        'resourceCenterXinhuaModule',
        'resourceCenterStockModule',
        'resourceCenterThemeModule',
        'resourceCenterServiceModule',
        'resourceCenterDetailModule', // 资源中心详情页（集团成品、分类资源）
        'resourceCenterXhsgBigdataDetailModule', // 新华社稿详情页
        'resourceCenterPushDetailModule', // push稿详情页
        'resourceCenterRobotDetailModule', // 机器人稿详情页
        'appResourceDetailModule',
        'resourceCenterGxgkDetailModule', // 共享稿库详情页
        'resourceCenterPictureDetailModule', // 图片素材详情页
        'resourceCenterVideoMaterialDetailModule', // 视频素材详情页
        'createLeftModule',
        'dropdownModule',
        'resCenDigitalModule',
        'resAdvancedSearchModule', // 资源中心高级检索
        'multiMediaResourceModule', // 多媒体资源
        'resourceCenterVideoDetailModule', // 成品稿库-电视台详情页
        'resourceCenterMaterialsModule', // 公共素材库
        'tenantManuscriptModule', // 租户间稿库
        'propagandaManuscriptControlModule', // 宣传部稿库
        'newspaperRemarkModule', // 读报评报
        'resourceCenterMaterialModule', // 素材库
        'resourceCenterMediaResourceModule', // 媒资库
        'resourceListModule', // 资源中心列表指令模块
        'resourceCenterGlobalSearchModule', // 全局检索
        'resourceCenterXJRBModule', // 新疆日报稿库模块
    ])
    .controller('resourceCenterController', ['publicToolService', 'messagePublishService', function(publicToolService, messagePublishService) {
        publicToolService.queryModeconfiguration('copyrightResource');
    }]);
